import React from "react";
import CustomSelect from "../../globalcontrols/customselect/customselect";
import "./css/salesrankings.css";

function SalesRankingControl({
  selectedLocation,
  setSelectedLocation,
  locations,
  error,
  loading,
  timeBase,
  setTimeBase,
  rankingData,
  timeFilter,
  setTimeFilter,
}) {
  const timeBaseOptions = [
    { label: "Día semanal", value: "weekday" },
    { label: "Mes", value: "monthly" },
    { label: "Año", value: "yearly" },
    { label: "Hora", value: "hourly" },
  ];
  const weekdayOptions = [
    ["Lunes", "Monday"], ["Martes", "Tuesday"], ["Miércoles", "Wednesday"],
    ["Jueves", "Thursday"], ["Viernes", "Friday"], ["Sábado", "Saturday"], ["Domingo", "Sunday"],
  ].map(([label, value]) => ({ label, value }));
  const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
  const monthOptions = monthNames.map((label, index) => ({ label, value: String(index + 1).padStart(2, "0") }));
  const hourOptions = Array.from({ length: 15 }, (_, index) => {
    const hour = index + 7;
    return { label: `${String(hour).padStart(2, "0")}:00`, value: String(hour) };
  });
  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from({ length: 6 }, (_, index) => ({
    label: String(currentYear - index),
    value: String(currentYear - index),
  }));
  const filterOptions = timeBase === "monthly"
    ? monthOptions
    : timeBase === "yearly"
      ? yearOptions
      : timeBase === "hourly"
        ? hourOptions
        : weekdayOptions;

  return (
    <section className="dashboard-card ranking-card" aria-labelledby="ranking-title">
      <div className="card-heading">
        <div>
          <p className="card-kicker">Rendimiento</p>
          <h2 id="ranking-title">Productos destacados</h2>
        </div>
      </div>

      <div className="dashboard-filters compact" aria-label="Filtros del ranking">
        <CustomSelect
          label="Ubicación"
          options={locations}
          selectedValue={selectedLocation}
          onChange={setSelectedLocation}
          labelExtractor={(item) => item.name}
          valueExtractor={(item) => item.id.toString()}
        />
        <CustomSelect
          label="Periodo"
          options={timeBaseOptions}
          selectedValue={timeBase}
          onChange={setTimeBase}
          labelExtractor={(item) => item.label}
          valueExtractor={(item) => item.value}
        />
        <CustomSelect
          label="Detalle"
          options={filterOptions}
          selectedValue={timeFilter}
          onChange={setTimeFilter}
          labelExtractor={(item) => item.label}
          valueExtractor={(item) => item.value}
        />
      </div>

      {error && <div className="dashboard-alert" role="alert">{error}</div>}
      {loading ? (
        <div className="dashboard-loading" role="status">Actualizando ranking…</div>
      ) : rankingData.length === 0 ? (
        <div className="empty-state">No hay ventas para este periodo.</div>
      ) : (
        <ol className="ranking-list">
          {rankingData.map((item, index) => (
            <li key={`${item.code}-${item.period || item.hour}`}>
              <span className={`rank-number rank-${index + 1}`}>{index + 1}</span>
              <div className="rank-product">
                <strong>{item.description || item.code}</strong>
                <span>{item.code}</span>
              </div>
              <div className="rank-values">
                <strong>{Number(item.total_quantity || 0).toLocaleString("es-CL")} un.</strong>
                <span>${Number(item.total_revenue || 0).toLocaleString("es-CL")}</span>
              </div>
              <button
                className="icon-button"
                type="button"
                onClick={() => navigator.clipboard.writeText(item.code)}
                aria-label={`Copiar código ${item.code}`}
              >
                <span className="material-symbols-outlined" aria-hidden="true">content_copy</span>
              </button>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}

export default SalesRankingControl;
